// extracted by mini-css-extract-plugin
export default {"link":"AuthSidebar_link__N0RHJ","linkIcon":"AuthSidebar_linkIcon__f5oNK"};